
/* eslint-disable no-alert */
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';

import config from '../../config/config';
import { useBranding } from '../../context/BrandingContext';
import MyButton from '../../shared-components/button/button';
import CustomInput from '../../shared-components/custom-input/CustomInput';
import getFirstSubdomain from '../../shared-functions/DomiansplitFunction';
import {
  getLocalStorageItem,
  removeLocalStorageItem,
  setLocalStorageItem,
} from '../../shared-functions/LocalStorage';
import charger from '../../utils/api/charger';
// import hyperPay from '../../utils/api/hyperPay';

/**
 * Apple Pay Component
 * @returns The rendered HyperPay Apple Pay demo element.
 */
function HyperPayApplePayComponent() {
  const { t } = useTranslation('hyperPay');
  const { search } = useLocation();
  const domain = getFirstSubdomain();
  const { brandData } = useBranding();
  const navigate = useNavigate();
  const [guestToken, setGuestToken] = useState(getLocalStorageItem('guestToken'));
  const [checkoutId, setCheckoutId] = useState<string>('');
  const [checkoutAppleId, setCheckoutAppleId] = useState<string>('');
  const message = getLocalStorageItem('apiResponse');

  /**
   * submitCheckoutId
   */
  const submitCheckoutId = () => {
    alert(JSON.stringify({ checkoutId }));
    // ✅ Define global config before loading the script
    (window as any).wpwlOptions = {
      style: 'plain',
      paymentTarget: '_top',
      applePay: {
        // displayName: 'Energic App',
        // totalLabel: 'Energic Charge',
        displayName: 'Energic App',
        total: { label: 'Energic Charge' },
        supportedNetworks: ['masterCard', 'visa', 'mada'],
        supportedCountries: ['SA'],
        version: 3,
        countryCode: 'SA',
      },
      /**
       * On ready callback
       */
      onReady: () => alert(t('widgetReady')),
      /**
       * On error callback
       * @param error - The error object from widget.
       */
      onError: (error: any) => {
        alert(`⚠️ ${t('widgetError')}: ${JSON.stringify(error)}`);
      },
      /**
       * On payment completed callback
       * @param result - The payment completion result.
       */
      onPaymentCompleted: (result: any) => {
        alert(`✅ ${t('paymentSuccess')}: ${JSON.stringify(result)}`);
      },
      /**
       * On payment failed callback
       * @param result - The payment failure result.
       */
      onPaymentFailed: (result: any) => {
        alert(`❌ ${t('paymentFailed')}: ${JSON.stringify(result)}`);
      },
    };
    // ✅ Now safely append the widget script
    const script = document.createElement('script');
    script.src = `${domain && brandData?.hyperPayScriptUrl ? brandData?.hyperPayScriptUrl : config.hyperPayScriptUrl}?checkoutId=${checkoutId}`;
    script.async = true;
    document.body.appendChild(script);
  };
  /**
   * submitCheckoutAppleId
   */
  const submitCheckoutAppleId = () => {
    alert(JSON.stringify({ checkoutAppleId }));
    // ✅ Define global config before loading the script
    (window as any).wpwlOptions = {
      style: 'plain',
      paymentTarget: '_top',
      applePay: {
        // displayName: 'Energic App',
        // totalLabel: 'Energic Charge',
        displayName: 'Energic App',
        total: { label: 'Energic Charge' },
        supportedNetworks: ['masterCard', 'visa', 'mada'],
        supportedCountries: ['SA'],
        version: 3,
        countryCode: 'SA',
      },
      /**
       * On ready callback
       */
      onReady: () => alert(t('widgetReady')),
      /**
       * On error callback
       * @param error - The error object from widget.
       */
      onError: (error: any) => {
        alert(`⚠️ ${t('widgetError')}: ${JSON.stringify(error)}`);
      },
      /**
       * On payment completed callback
       * @param result - The payment completion result.
       */
      onPaymentCompleted: (result: any) => {
        alert(`✅ ${t('paymentSuccess')}: ${JSON.stringify(result)}`);
      },
      /**
       * On payment failed callback
       * @param result - The payment failure result.
       */
      onPaymentFailed: (result: any) => {
        alert(`❌ ${t('paymentFailed')}: ${JSON.stringify(result)}`);
      },
    };
    // ✅ Now safely append the widget script
    const script = document.createElement('script');
    script.src = `${domain && brandData?.hyperPayScriptUrl ? brandData?.hyperPayScriptUrl : config.hyperPayScriptUrl}?checkoutId=${checkoutAppleId}`;
    script.async = true;
    document.body.appendChild(script);
  };

  /**
   * changeInput
   * @param name - The field name.
   * @param value - The input value.
   */
  const changeInput = (name: string, value: string | number) => {
    setCheckoutId(String(value));
  };

  /**
   * changeInput
   * @param name - The field name.
   * @param value - The input value.
   */
  const changeInputApple = (name: string, value: string | number) => {
    setCheckoutAppleId(String(value));
  };

  /**
   * Get the guest token api call
   */
  const getGuestToken = async () => {
    // const response1 = await hyperPay.generateCheckoutId();
    // setCheckoutId(response1?.data?.checkoutId);
    removeLocalStorageItem('apiResponse');
    if (!guestToken) {
      const response = await charger.generateTempToken();
      setGuestToken(response?.data?.guestToken);
      setLocalStorageItem('guestToken', response?.data?.guestToken);
    }

    if (search) {
      console.log(search);
      setLocalStorageItem('apiResponse', search);
      navigate('/apple-pay/demo');
    }
  };
  useEffect(() => { 
    getGuestToken();
  }, []);

  return (
    <div className="flex justify-center p-10 bg-gray-100 min-h-screen">
      <h2 className="text-xl font-semibold text-center mb-6">{t('addCardTitle')}</h2>
      <div
        style={{
          display: 'flex',
          gap: '10px',
          alignItems: 'end',
          padding: '20px',
        }}>
        <CustomInput
          inputLabel={t('checkoutIdLabel')}
          value={checkoutId}
          type="text"
          placeholder={t('checkoutIdPlaceholder')}
          name="name"
          onChangeValue={changeInput}
          valueRequired
        />
        <MyButton label={t('applyCheckoutIdBtn')} buttonType="submit" onClickFunc={submitCheckoutId} />
      </div>
      <div
        style={{
          display: 'flex',
          gap: '10px',
          alignItems: 'end',
          padding: '20px',
        }}>
        <CustomInput
          inputLabel={t('appleCheckoutIdLabel')}
          value={checkoutAppleId}
          type="text"
          placeholder={t('appleCheckoutIdPlaceholder')}
          name="name"
          onChangeValue={changeInputApple}
          valueRequired
        />
        <MyButton label={t('applyCheckoutIdBtn')} buttonType="submit" onClickFunc={submitCheckoutAppleId} />
      </div>
      {checkoutId && (
        <form
          action={window.location.href}
          className="paymentWidgets"
          data-brands="VISA MASTER MADA AMEX"
        />
      )}
      {checkoutAppleId && (
        <form action={window.location.href} className="paymentWidgets" data-brands="APPLEPAY" />
      )}
      <div>{message}</div>
    </div>
  );
}

export default HyperPayApplePayComponent;
